class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.closedExpiryDays = 30;       // Don't show again for 30 days after dismissing
    this.subscribedExpiryDays = 365;   // Don't show again for 1 year after subscribing
    this.scrollThreshold = 50;         // Show after user scrolls 50% of page
    this.hasTriggered = false;         // Prevent multiple triggers
    this.init();
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");
    this.buttonClose.addEventListener("click", this.closeNewsletter.bind(this));

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }
  }

  init() {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
  }

  closeNewsletter() {
    setCookie("newsletter-closed", "true", this.closedExpiryDays);
    this.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
        this.show();
      }
      return;
    }

    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.startSmartTriggers();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.startSmartTriggers();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  // Replaces the old simple delay with smarter triggers
  startSmartTriggers() {
    if (this.closed === "true" || this.subscribed === "true") return;

    // 1. Exit intent detection (desktop only)
    this.exitIntentHandler = this.onExitIntent.bind(this);
    document.addEventListener("mouseout", this.exitIntentHandler);

    // 2. Scroll depth trigger - shows after user scrolls past threshold
    this.scrollHandler = this.onScroll.bind(this);
    window.addEventListener("scroll", this.scrollHandler, { passive: true });

    // 3. Fallback timer - if neither exit intent nor scroll triggers fire,
    //    show after delay as a safety net (uses the delay from theme settings)
    this.fallbackTimer = setTimeout(() => {
      this.triggerPopup("fallback");
    }, this.delay);
  }

  // Exit intent: fires when mouse leaves toward the top of the viewport
  onExitIntent(e) {
    if (e.clientY <= 5 && e.relatedTarget === null) {
      this.triggerPopup("exit-intent");
    }
  }

  // Scroll depth: fires when user has scrolled past the threshold percentage
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = (scrollTop / docHeight) * 100;

    if (scrollPercent >= this.scrollThreshold) {
      this.triggerPopup("scroll");
    }
  }

  // Central method to show popup and clean up all listeners
  triggerPopup(source) {
    if (this.hasTriggered) return;
    this.hasTriggered = true;

    // Clean up all event listeners and timers
    this.cleanupTriggers();

    this.show();
  }

  cleanupTriggers() {
    if (this.exitIntentHandler) {
      document.removeEventListener("mouseout", this.exitIntentHandler);
    }
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler);
    }
    if (this.fallbackTimer) {
      clearTimeout(this.fallbackTimer);
    }
  }

  onSubscribe() {
    setCookie("newsletter-subscribed", "true", this.subscribedExpiryDays);
    this.hide();
  }
}

customElements.define("newsletter-popup", NewsletterPopup);